export const PAGE_CONTENT_SPACING = '800';